import { css } from "@emotion/css";
import { StatsCountMiniXD } from "models/mini-xd-model";

interface Props {
    statsData: StatsCountMiniXD;
    hisIssueList: number[][];
}
export default function StatsMiniXD(props: Props) {
    const { statsData, hisIssueList } = props;
    return (
        <div className={styles.statsTable}>
            <div className="col-item col-1">
                <div className="stats-item">
                    <p className="title"> CHẴN </p>
                    <p> {statsData.chan} </p>
                </div>
                <div className="stats-item">
                    <p className="title"> LẺ </p>
                    <p> {statsData.le} </p>
                </div>
            </div>
            <div className="col-item col-2">
                <div className="stats-color">
                    <div className="dots">
                        <img src={require(`assets/images/mini-xd/red.png`)} alt="" />
                        <img src={require(`assets/images/mini-xd/red.png`)} alt="" />
                        <img src={require(`assets/images/mini-xd/red.png`)} alt="" />
                        <img src={require(`assets/images/mini-xd/white.png`)} alt="" />
                    </div>
                    <p>{statsData.num3}</p>
                </div>
                <div className="stats-color">
                    <div className="dots">
                        <img src={require(`assets/images/mini-xd/white.png`)} alt="" />
                        <img src={require(`assets/images/mini-xd/white.png`)} alt="" />
                        <img src={require(`assets/images/mini-xd/white.png`)} alt="" />
                        <img src={require(`assets/images/mini-xd/red.png`)} alt="" />
                    </div>
                    <p>{statsData.num1}</p>
                </div>
                <div className="stats-color">
                    <div className="dots">
                        <img src={require(`assets/images/mini-xd/red.png`)} alt="" />
                        <img src={require(`assets/images/mini-xd/red.png`)} alt="" />
                        <img src={require(`assets/images/mini-xd/red.png`)} alt="" />
                        <img src={require(`assets/images/mini-xd/red.png`)} alt="" />
                    </div>
                    <p>{statsData.num4}</p>
                </div>
                <div className="stats-color">
                    <div className="dots">
                        <img src={require(`assets/images/mini-xd/white.png`)} alt="" />
                        <img src={require(`assets/images/mini-xd/white.png`)} alt="" />
                        <img src={require(`assets/images/mini-xd/white.png`)} alt="" />
                        <img src={require(`assets/images/mini-xd/white.png`)} alt="" />
                    </div>
                    <p>{statsData.num0}</p>
                </div>
            </div>
            <div className="col-item col-3">
                <div className="stats-list">
                    {hisIssueList.map((issue, index) => (
                        <div className="issue" key={index}>
                            {issue.map((dice, idx) => (
                                <img key={idx} src={require(`assets/images/mini-xd/dice-${dice}.png`)} alt="" />
                            ))}
                        </div>
                    ))}
                </div>
                <img className="arrow-icon" src={require(`assets/images/mini-xd/arrow-stats.png`)} alt="" />
            </div>
        </div>
    );
}

const styles = {
    statsTable: css`
        padding: 4px;
        background: #490012;
        border: 1px solid #c0a287;
        border-radius: 8px;
        display: flex;
        gap: 6px;
        margin-bottom: 10px;
        img {
            width: 11px;
        }
        .col-1 {
            display: flex;
            flex-direction: column;
            background: #05175b;
            border-radius: 4px;
            border: 1px solid var(--ion-color-secondary);
            padding: 4px;
            .stats-item {
                flex: 1;
                display: flex;
                flex-direction: column;
                color: #fff;
                padding: 2px 0;
                &:first-child {
                    border-bottom: 1px solid var(--ion-color-secondary);
                }
                p {
                    font-size: 11px;
                    text-align: center;
                    font-weight: 600;
                }
                .title {
                    color: var(--ion-color-secondary);
                }
            }
        }
        .col-2 {
            flex: 0 0 42%;
            max-width: 42%;
            background: rgba(5, 23, 91, 0.7);
            border: 1px solid #3d429e;
            border-radius: 4px;
            display: flex;
            padding: 2px;
            flex-wrap: wrap;
            gap: 2px;
            .stats-color {
                flex: 0 0 calc(50% - 2px);
                max-width: calc(50% - 2px);
                display: flex;
                align-items: center;
                background: rgba(39, 39, 136, 0.6);
                padding: 0 2px;
                border-radius: 4px;
                justify-content: space-between;
                flex-direction: column-reverse;
                p {
                    color: #fff;
                    font-size: 14px;
                    font-weight: 600;
                }
                .dots {
                    display: flex;
                    align-items: center;
                    gap: 2px;
                }
            }
        }
        .col-3 {
            flex: 1;
            background: rgba(5, 23, 91, 0.7);
            border-radius: 8px;
            border: 1px solid #3d429e;
            display: flex;
            align-items: center;
            .stats-list {
                flex: 1;
                display: flex;
                height: 100%;
                justify-content: space-between;
                padding: 2px;
                .issue {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    gap: 2px;
                    background: #000000;
                    padding: 2px;
                    border-right: 1px solid #646464;
                    &:last-child {
                        border-right: none;
                    }
                }
            }
            .arrow-icon {
                width: 7px;
            }
        }
    `,
};
